import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_LOCATIONS/REQUESTED';
const BLOCKED = '$FETCH_LOCATIONS/BLOCKED';
const APPROVED = '$FETCH_LOCATIONS/APPROVED';
const SUCCEEDED = '$FETCH_LOCATIONS/SUCCEEDED';
const FAILED = '$FETCH_LOCATIONS/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      locationId?: string;
      rawLocations?: RawLocation[];
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      locations: SDict<POSLocation>;
      merge?: boolean;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
